'use client';

import { SvgChatbubbleQuestionFill } from '@common/icon';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';

import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_ROUTES } from '@/constants';

import { useCategory } from './_hooks/useCategory';
import { Agencies } from './Agencies';
import { CategoryDropdown } from './CategoryDropdown';

export const DONATION_SUB_HEADER_HEIGHT = 56;

export const DonationSubHeader = () => {
  const pathname = usePathname();
  const { categoryData } = useCategory();

  return (
    <div
      className="sticky top-72 z-10 w-full bg-Gray-white mobile:hidden tablet:hidden"
      style={{ height: DONATION_SUB_HEADER_HEIGHT }}
    >
      <nav className="mx-auto flex h-full max-w-screen-xl items-center justify-between px-40">
        <ul className="flex items-center gap-12">
          <li>
            <CategoryDropdown categories={categoryData} className="-ml-24" />
          </li>
          <li className="flex items-center">
            <SubLink
              href={DONATION_ROUTES.GIFTS.pathname}
              isSelected={DONATION_ROUTES.GIFTS.pathname === pathname}
            >
              답례품
            </SubLink>
            <SubLink
              href={DONATION_ROUTES.HOMETOWNS_BUSINESS.pathname}
              isSelected={
                DONATION_ROUTES.HOMETOWNS_BUSINESS.pathname === pathname
              }
            >
              지정기부사업
            </SubLink>
            <SubLink
              href={DONATION_ROUTES.MY_ETC_EVENT.pathname}
              isSelected={DONATION_ROUTES.MY_ETC_EVENT.pathname === pathname}
            >
              이벤트
            </SubLink>
            <SubLink
              href={DONATION_ROUTES.GUIDE.pathname}
              isSelected={DONATION_ROUTES.GUIDE.pathname === pathname}
            >
              고향사랑기부 안내
              <SvgChatbubbleQuestionFill className="ml-4 size-16 text-B-500" />
            </SubLink>
          </li>
        </ul>
        <Agencies />
      </nav>
    </div>
  );
};

const SubLink = ({
  href,
  isSelected,
  children,
}: {
  href: string;
  isSelected: boolean;
  children: React.ReactNode;
}) => (
  <CustomLink
    href={href}
    aria-current={isSelected ? 'page' : undefined}
    className={cn(
      'flex h-56 items-center px-24 transition-colors typo-body3',
      isSelected
        ? 'font-700 text-Gray-800'
        : 'font-600 text-Gray-500 hover:text-Gray-700',
    )}
  >
    {children}
  </CustomLink>
);
